
class Accordion {
    
    constructor() {

        this.accTitle    = document.getElementsByClassName("accordion__item__term");
        this.accContent  = document.getElementsByClassName("accordion__item__definition");
        this.singleMode  = true;
        this.firstActive = false;

        // Els
      //  this.id = id;
       
        window.addEventListener("resize", this.resize);

        this.init();
    }

    init() {

      for( let j=0; j<this.accContent.length; j++ ){

        // Make sure text nodes are wrapped in <p> tags, where <ul> are found
        if (this.accContent[j].querySelector(".content ul") != null) {
          const textNodes = Array.from(this.accContent[j].querySelector(".content").childNodes)
            .filter(node => node.nodeType === 3 && node.textContent.trim().length > 1)

          textNodes.forEach(node => {
            const parag = document.createElement('p');
            node.after(parag);
            parag.appendChild(node);
          });
        }

        let realHeight = this.accContent[j].offsetHeight;
        this.accContent[j].setAttribute("data-height", realHeight + "px");

        // Make sure element is not already open
        if (!this.accTitle[j].classList.contains("active")) {
          this.accContent[j].style.height = 0;
          console.log("Height 0");
        }
      }
      
      for( let i=0; i < this.accTitle.length; i++ ){

        // Remove WP generated BR
        this.accTitle[i].parentNode.querySelectorAll("br").forEach(
          el => el.remove()
        );

        let $this = this;
        this.accTitle[i].addEventListener("click", function(){
          $this.toggle($this.accTitle[i]);
        });

        if (this.firstActive && i==0) {
          // this.accTitle[i].click();
        }

      }

    }

    toggle( elem ) {

       let accTargetContent = elem.nextElementSibling;

        if( elem.classList.contains("active") ){
          elem.classList.remove("active");
          accTargetContent.style.height = 0;
          return false;
        }
        
        if( this.singleMode ){           
          for(let k=0; k<this.accTitle.length; k++) {
            this.accTitle[k].classList.remove("active");
          }

          for(let j=0; j<this.accContent.length; j++) {
            this.accContent[j].style.height = 0;
          }
        }
        
        elem.classList.add("active");
        accTargetContent.style.height = accTargetContent.getAttribute("data-height");
        
    }

    resize() {
      
        if (this.accContent == null) return false;

        for( let j=0; j<this.accContent.length; j++ ){
          this.accContent[j].removeAttribute('style');
          let realHeight = this.accContent[j].offsetHeight;
          this.accContent[j].setAttribute("data-height", realHeight + "px");

          if ( this.accTitle[j].classList.contains('active') ) {
              this.accContent[j].style.height = this.accContent[j].getAttribute("data-height");
          } else {
              this.accContent[j].style.height = 0;
          }
        }
    }

}

export default Accordion;



// WEBPACK FOOTER //
// ./scripts/components/accordion.js